import type { SelectMode } from './ElasticPaginatedSelect.interfaces';

/**
 * Single-select: Ant Design 4 fires both `onSelect` and `onChange` on pick.
 * Commit picks from `onSelect` only; let `onChange` handle clear (and all
 * multiple-mode updates) so parents are not notified twice.
 */
export const shouldCommitElasticSelectOnChange = (
  mode: SelectMode | undefined,
  newValue: string | string[] | undefined,
): boolean => {
  if (mode) return true;
  if (newValue == null || newValue === '') return true;
  if (Array.isArray(newValue) && newValue.length === 0) return true;
  return false;
};
